import React, { useEffect, useState } from "react";
import { CustomButton } from "../UI/CustomButtons";
import ActionsDropdown from "./ActionsDropdown";
import SearchInputTable from "../common/SearchInputTable";
import AddCategoryPopup from "./AddCategoryPopup";
import SuccessPopup from "./SuccessPopup";
import {
  deleteAuthToken,
  notifyError,
  notifySuccess,
} from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { addCategory, fetchCategories, updateCategory } from "../../requests";
import { formatCategoriesList } from "../helper/formatters";
import ActionsDropdownCategory from "./ActionsDropdownCategory";
import DeleteUserModal from "../UI/DeleteUserModal";

function Categories({ styles, setSelectedCategory, selectedCategory }) {
  const [selectedCategoryId, setSelectedCategoryId] = useState(1);
  const [showAddCategoryPopup, setShowAddCategoryPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState({
    isOpen: false,
    categoryName: "",
  });
  const [categoryList, setCategoryList] = useState([]);
  const [showDeleteCategoryModal, setShowDeleteCategoryModal] = useState(false);
  const [selectedCategoryAction, setSelectedCategoryAction] = useState(null);

  const { refreshSession } = useSelector((state) => state.refreshSessionData);
  const dispatch = useDispatch();

  useEffect(() => {
    getAllCategories();
  }, [refreshSession]);

  const handleCreateCategory = async (e, data) => {
    e.preventDefault();
    if (!data.titleEn || !data.titleAr) {
      notifyError("Please fill all the fields");
      return;
    }
    dispatch(startLoader());
    try {
      const response = await addCategory(data);
      if (response.status === 200) {
        if (data.id) {
          notifySuccess("Category updated successfully");
        } else {
          notifySuccess("Category created successfully");
          setShowSuccessPopup({
            isOpen: true,
            categoryName: data.titleEn,
          });
        }
        setShowAddCategoryPopup(false);
        getAllCategories();
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    } finally {
      dispatch(stopLoader());
    }

  };

  const getAllCategories = async () => {
    dispatch(startLoader());
    try {
      const response = await fetchCategories();
      const formattedCategories = formatCategoriesList(
        response.data.categoryResult
      );
      setCategoryList(formattedCategories);
      if (!selectedCategoryId) {
        setSelectedCategoryId(formattedCategories[0].id);
      }
      if (!selectedCategory) {
        setSelectedCategory(formattedCategories[0]);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };

  const handleCategoryUpdate = async (categoryId, data) => {
    dispatch(startLoader());
    try {
      const response = await updateCategory({
        id: categoryId,
        ...data,
      });
      if (response.status === 200) {
        if (data.status === 9) {
          notifySuccess("Category deleted successfully");
        } else {
          notifySuccess("Category updated successfully");
        }
        getAllCategories();
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }
    dispatch(stopLoader());
  };

  return (
    <div style={{ width: "30%" }} className={styles.container}>
      <DeleteUserModal
        show={showDeleteCategoryModal}
        onHide={() => setShowDeleteCategoryModal(false)}
        onDelete={() => {
          handleCategoryUpdate(selectedCategoryAction.id, {
            status: 9,
          });
          setShowDeleteCategoryModal(false);
        }}
        title="Delete Category"
        btnText="Delete"
        message="Are you sure you want to delete this category?"
      />
      <AddCategoryPopup
        show={showAddCategoryPopup}
        onHide={() => setShowAddCategoryPopup(false)}
        // showSuccessPopup={() => setShowSuccessPopup(true)}
        handleCreateCategory={handleCreateCategory}
        data={selectedCategoryAction}
      />
      <SuccessPopup
        show={showSuccessPopup.isOpen}
        onHide={() => setShowSuccessPopup(false)}
        categoryName={showSuccessPopup.categoryName}
      />
      <div className={styles.headerContainer}>
        <h5 className={styles.header}>Categories</h5>
        <CustomButton
          text="Add Category"
          onClick={() => setShowAddCategoryPopup(true)}
        />
      </div>
      <hr className="m-0" />
      <div className={styles.categoriesContainer}>
        <SearchInputTable placeholder="Search Category" width="100%" />
        {categoryList.map((category) => (
          <div
            onClick={() => {
              setSelectedCategoryId(category.id);
              setSelectedCategory(category);
            }}
            key={category.id}
            className={
              styles.categoryItem +
              " " +
              (category.id === selectedCategoryId
                ? styles.categoryItemSelected
                : "")
            }
          >
            <div>
              <p>{category.name}</p>
              <span>{category.sessionCount} Sessions</span>
            </div>
            <ActionsDropdownCategory
              onSwitchCategoryVisibility={(switchValue) => {
                handleCategoryUpdate(category.id, {
                  status: switchValue ? 1 : 0,
                });
              }}
              onRenameCategory={() => {
                setShowAddCategoryPopup(true);
                setSelectedCategoryAction(category);
              }}
              onRemoveCategory={() => {
                setShowDeleteCategoryModal(true);
                setSelectedCategoryAction(category);
              }}
              isVisible={category.isVisible}
              styles={styles}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Categories;
